function home() {
    const homepage = document.querySelector('[data-art-home]');

    if (!homepage) {
        return;
    }

    homepage.querySelectorAll('[data-audio-preview-toggle]').forEach((toggle) => {
        const player = document.getElementById(toggle.getAttribute('aria-controls'));
        const label = toggle.querySelector('[data-audio-preview-label]');

        if (!player) {
            return;
        }

        toggle.addEventListener('click', () => {
            const isOpen = toggle.getAttribute('aria-expanded') === 'true';

            toggle.setAttribute('aria-expanded', String(!isOpen));
            player.hidden = isOpen;

            if (label) {
                label.textContent = isOpen ? 'Open player' : 'Close player';
            }
        });
    });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const introItems = Array.from(homepage.querySelectorAll('[data-home-intro]'));
    const revealItems = Array.from(homepage.querySelectorAll('[data-home-reveal]'));

    if (reducedMotion) {
        introItems.concat(revealItems).forEach((item) => item.classList.add('is-visible'));
    } else {
        homepage.classList.add('is-motion-ready');

        window.requestAnimationFrame(() => {
            introItems.forEach((item, index) => {
                window.setTimeout(() => item.classList.add('is-visible'), 120 + (index * 110));
            });
        });

        const revealObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            });
        }, {
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.12,
        });

        revealItems.forEach((item) => revealObserver.observe(item));
    }


    const hero = homepage.querySelector('.art-home__hero');

    if (hero && window.matchMedia('(pointer: fine)').matches) {
        hero.addEventListener('pointermove', (event) => {
            const bounds = hero.getBoundingClientRect();
            const x = ((event.clientX - bounds.left) / bounds.width) - 0.5;
            const y = ((event.clientY - bounds.top) / bounds.height) - 0.5;

            hero.style.setProperty('--art-pointer-x', `${x * -10}px`);
            hero.style.setProperty('--art-pointer-y', `${y * -7}px`);
        });

        hero.addEventListener('pointerleave', () => {
            hero.style.setProperty('--art-pointer-x', '0px');
            hero.style.setProperty('--art-pointer-y', '0px');
        });
    }

    const library = homepage.querySelector('[data-public-library]');

    if (library) {
        const filters = Array.from(library.querySelectorAll('[data-library-filter]'));
        const items = Array.from(library.querySelectorAll('[data-library-item]'));
        const empty = library.querySelector('[data-library-filter-empty]');

        filters.forEach((filter) => {
            filter.addEventListener('click', () => {
                const selected = filter.dataset.libraryFilter;
                let visible = 0;

                filters.forEach((button) => {
                    const active = button === filter;
                    button.classList.toggle('is-active', active);
                    button.setAttribute('aria-pressed', String(active));
                });

                items.forEach((item) => {
                    const matches = selected === 'all' || item.dataset.libraryItem === selected;
                    item.hidden = !matches;
                    visible += matches ? 1 : 0;
                });

                if (empty) {
                    empty.hidden = visible > 0;
                }
            });
        });

        library.querySelectorAll('video').forEach((video) => {
            video.addEventListener('pointerenter', () => video.play().catch(() => {}));
            video.addEventListener('pointerleave', () => video.pause());
        });
    }

}

export {home};
